import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UpdateUserMembershipTypeDto, UserMembershipTypeDto } from '../../../models/user-membership/dto/user-membership.dto';
import { GET_USER_MEMBERSHIP_TYPES_QUERY_KEY } from './useGetUserMembershipTypes';

export const useDeleteUserMembershipType = (membershipTypeId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['deleteUserMembershipType', membershipTypeId],
        mutationFn: async (body: UserMembershipTypeDto) => {
            const response = await apiClient.fetchApi<{}, UpdateUserMembershipTypeDto>({ method: 'DELETE', endpoint: `user-membership-types/${membershipTypeId}`, body });
            return response
        },
        onSuccess: (data: {}, variables: UserMembershipTypeDto) => {
            queryClient.setQueryData<UserMembershipTypeDto[]>(GET_USER_MEMBERSHIP_TYPES_QUERY_KEY(variables.organizationId), (previousData) => {
                return [...(previousData || []).filter(item => item.id !== membershipTypeId)];
            });
        }
    });
};